import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import Image from '@web/components/common/Image';
import { ThemeProvider } from 'react-native-elements-light';
import PropTypes from 'prop-types';
//
import OpenURLButton from '@web-components/common/OpenURLButton';
import { purpleSmall } from '@web/styles/buttons';
import Colors from '~global/Colors';
//
const LoginHeader = (props) => {
  const { onClose } = props;
  return (
    <View style={styles.container}>
      <Pressable onPress={onClose}>
        <Image
          source={require('~assets/img/common/icon-close.svg')}
          style={styles.close}
        />
      </Pressable>
      <Image
        source={require('~assets/img/header/square-logo.png')}
        style={styles.logo}
      />
      <View>
        <Text style={styles.text1}>Lilla</Text>
        <Text style={styles.text2}>Open in Lilla App</Text>
      </View>
      <View style={styles.button}>
        <ThemeProvider theme={purpleSmall}>
          <OpenURLButton />
        </ThemeProvider>
      </View>
    </View>
  );
};

LoginHeader.propTypes = {
  onClose: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: Colors.purple24,
    flex: 1,
    flexDirection: 'row',
    padding: 10,
  },
  close: { width: 10, height: 10, marginRight: 5 },
  logo: { width: 40, height: 40, marginRight: 10 },
  text1: {
    color: Colors.purple7,
    fontFamily: 'figtree-black',
    fontSize: 14,
    lineHeight: 17,
    textTransform: 'uppercase',
  },
  text2: {
    color: Colors.white,
    fontFamily: 'figtree-bold',
    fontSize: 13,
    lineHeight: 13,
  },
  button: { marginLeft: 'auto' },
});

export default LoginHeader;
